import * as React from 'react'

import { CloudUploadIcon } from 'lucide-react'
import { action, makeObservable, observable } from 'mobx'
import { observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'
import Dropzone from 'react-dropzone'

import UploadButton from '~/client/src/desktop/components/UploadButton/UploadButton'
import FileType from '~/client/src/shared/enums/FileType'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import './DndArea.scss'

const ICON_SIZE = 16

interface IProps {
  fileUploadHandler?: (fileData: any, file: File) => void
  title?: string | JSX.Element
  fileType: FileType
  accept?: string | string[]
  onDrop: (file: File | Buffer | Blob) => void
  isHidden?: boolean
  isSmall?: boolean
  shouldRenderIcon?: boolean
  className?: string
  dropzoneClassName?: string
  isDisabled?: boolean
}

@observer
export default class DndArea extends React.Component<IProps> {
  private readonly defaultAccept = '.xer,.xlsx,.xlsm'
  private uploadStates = {
    NotSelected: 0,
    Selected: 1,
  }

  @observable private uploadState = this.uploadStates.NotSelected
  private file: File

  public constructor(props: IProps) {
    super(props)
    makeObservable(this)
  }

  @action.bound
  public onDrop(acceptedFiles: File[]) {
    if (!acceptedFiles || !acceptedFiles.length) {
      return
    }

    this.file = acceptedFiles[0]
    this.uploadState = this.uploadStates.Selected
    this.props.onDrop(this.file)
  }

  public render() {
    const {
      accept,
      isHidden,
      isSmall,
      isDisabled,
      shouldRenderIcon,
      className = 'upload-schedule-dnd-container col mb20 mt20 x-center y-center',
      dropzoneClassName,
    } = this.props

    return (
      <div
        className={classList({
          [className]: true,
          disabled: isDisabled,
          hidden: isHidden,
        })}
      >
        <Dropzone
          className={classList({
            'upload-schedule-block upload-schedule-block-bordered col x-center y-center': true,
            small: isSmall,
            [dropzoneClassName]: !!dropzoneClassName,
          })}
          accept={accept || this.defaultAccept}
          onDrop={this.onDrop}
        >
          {shouldRenderIcon && (
            <CloudUploadIcon size={ICON_SIZE} className="no-grow" />
          )}
          {this.title}
        </Dropzone>
      </div>
    )
  }

  private get title() {
    const { title } = this.props
    if (title) {
      if (typeof title === 'string') {
        return (
          <span className="mw300 large text overflow-hidden ">{title}</span>
        )
      }

      return title
    }

    switch (this.uploadState) {
      case this.uploadStates.NotSelected:
        return (
          <>
            <UploadButton
              text={
                Localization.translator
                  .uploadYourScheduleFileInP6XerOrExcelXlsxXlsmFormat
              }
            />
            <div className="row">
              <span className="text large">
                {Localization.translator.orDragYourFileHere}
              </span>
            </div>
          </>
        )
      case this.uploadStates.Selected:
        return <span>{Localization.translator.uploading}...</span>
    }
  }
}
